import React, {
  ReactElement, useEffect, useState,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { injectIntl } from 'react-intl';
import { useForm } from 'react-hook-form';
import {
  Button, Dropdown, Menu, message, Modal, Radio, Spin, Upload,
} from 'antd';
import { useHistory, generatePath, useParams, Prompt } from 'react-router-dom';
import { find } from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown } from '@fortawesome/pro-light-svg-icons';
import { faPrint, faEllipsisH } from '@fortawesome/pro-light-svg-icons';
import moment from 'moment';
import * as actions from '../../../../state/actions/creators/pacientes.actioncreator';
import BasicInfo from '../../components/newPatient/basicInfo';
import ContactInfo from '../../components/newPatient/contactInfo';
import AddInfo from '../../components/newPatient/addInfo';
import Mutuas from '../../components/newPatient/mutuas';
import Notas from '../../components/notas/notas';
import ModalDS from '../../components/newPatient/modalDS';
import { useBreakpoint } from '../../../../hooks/useBreakpoint';
import { ROUTE_PACIENTES_EDIT, ROUTE_PACIENTES_FILE } from '../../../../routes.constants';
import { requireAcompanyanteRule, requiredRule } from '../../components/newPatient/rules';
import Page from '../../../shared/components/layout/Page.layout';
import {
  Box,
  Text,
} from '../../../shared/components';
import ActionsHeader, { NAVIGATION_ANCHOR } from '../../../shared/containers/ActionsHeader';
import { valorPermiso } from '../../../../helpers/auth.helper';
import CancelModal from '../../../shared/components/dataDisplay/CancelModal';
import urlHelper from '../../../../helpers/url.helper';
import { GenderSelectPatient } from './genderSelectPatient';
import { getPhotoPaciente } from '../../../../state/actions/creators/pacientes.actioncreator';
interface NewClientProps {
  intl: any,
  create: boolean,
  watch: boolean
}

function NewPatient({ intl, create = true, watch = false }:NewClientProps) {
  const history = useHistory();
  const params: any = useParams();
  const dispatch = useDispatch();
  const [onWatch, setOnWatch] = useState(watch);
  const { usuario, tienda_id: tiendaId } = useSelector((state: any) => state.auth.user.user_info);
  const pacienteSelected = useSelector((state: any) => state.pacientesWorkspace.pacienteSelected);
  const sagas = useSelector((state: any) => state.sagas);
  const loadingFields = useSelector((state: any) => state.pacientesWorkspace.loadingFields);
  //const camposPersonalizados = useSelector((state: any) => state.pacientesWorkspace.camposPersonalizados);
  const camposDinamicos = useSelector((state: any) => state.pacientesWorkspace.camposDinamicos);
  const pacienteDuplicado = useSelector((state: any) => state.pacientesWorkspace.pacienteDuplicado);
  const pacienteEsperandoGuardado = useSelector((state: any) => state.pacientesWorkspace.pacienteEsperandoGuardado);
  const configuraciones = useSelector((state: any) => state.auth.permisos.configuracion);
  const notas = useSelector((state: any) => state.pacientesWorkspace.notas);
  const mutuas = useSelector((state: any) => state.pacientesWorkspace.pacienteSelected?.mutuas);
  const fotoPerfil = useSelector((state: any) => state.pacientesWorkspace.imagen);
  const [modalState, setModalState] = useState(false);
  const [duplicadoModal, setDuplicadoModal] = useState(false);
  const [saveRecordatory, setSaveRecordatory] = useState(true);


  const [cancelModalState, setCancelModalState] = useState(false);
  const [notasState, setNotasState] = useState('');
  const [pendingFormData, setPendingFormData] = useState({});
  const [edadState, setEdadState] = useState(null);
  const appNavigation = useSelector((state: any) => state.app.navigation);
  const [mutuasState, setMutuasState] = useState([{ key: 0, codigo_cliente_grupo: '', beneficiario: '' }]);
  const breakPoint = useBreakpoint();
  const fecha_nacimiento_paciente = pacienteSelected ? pacienteSelected.fecha_nacimiento : null;

  const guardandoPaciente = sagas?.PACIENTES_CREATE_PACIENTE?.running || sagas?.PACIENTES_UPDATE_PACIENTE?.running;
  const comprobandoDuplicidad = sagas?.COMPROBAR_PACIENTE_DUPLICADO?.running || sagas?.COMPROBAR_PACIENTE_DUPLICADO?.running;
  const duplicidadComprobada = sagas?.COMPROBAR_PACIENTE_DUPLICADO?.success || sagas?.COMPROBAR_PACIENTE_DUPLICADO?.success;
  const hookForms = useForm({
    mode: 'onBlur',
    defaultValues: {
      genero: 'O',
      es_empresa: false,
      nombre_1: '',
      notas: '',
      mutuas: [],
      avatar: '',
    },
  });

  const {
    handleSubmit, setValue, control, register, reset, getValues, clearErrors, unregister, trigger, watch: watchForm,
  } = hookForms;
  const genero = watchForm('genero');

  useEffect(() => {

    if (!comprobandoDuplicidad && pacienteEsperandoGuardado && create) {
      if (pacienteDuplicado) {
        setDuplicadoModal(true);
      } else {
        dispatch(actions.createPacienteAction(pendingFormData));
        setPendingFormData({});
      }
    }
  }, [pacienteEsperandoGuardado, comprobandoDuplicidad]);
  useEffect(() => {
    if(create) {
      dispatch(actions.initClientsWorkspace());
      sessionStorage.removeItem('infoNewPatient');
    }
    if(sessionStorage.getItem('infoNewPatient') === params.pacienteId) return;
    reset();
    dispatch(actions.getPacientesIdentificadores());
    //dispatch(actions.getPacientesCamposPersonalizados({ create }));
    if (!create) {
      const { pacienteId } = params;
      if (pacienteId) {
        dispatch(actions.getPaciente({
          tiendaId,
          pacienteId: parseInt(pacienteId, 10),
        }));
        dispatch(actions.getPhotoPaciente({
          pacienteId: parseInt(pacienteId, 10),
        }));
        if (pacienteSelected && !pacienteSelected.notas) {
          dispatch(actions.getPacienteNotas({ pacienteId }));
        }
      }
    }
    dispatch(actions.getPacientesCamposDinamicos({ create }));
    sessionStorage.setItem('infoNewPatient', params.pacienteId);
  }, []);
  
  useEffect(() => {
    // TODO: Se puede eliminar: Esta función sirve para rellenar formulario con los datos de paciente seleccionado, utilizando los campos personalizados.
    // if (camposPersonalizados && camposPersonalizados.length > 0) {
    //   camposPersonalizados.forEach((campoPersonalizado: any) => {
    //     if (pacienteSelected) {
    //       setValue(campoPersonalizado.campo_descripcion, pacienteSelected[campoPersonalizado.campo_descripcion]);
    //     } else if (campoPersonalizado.propiedades.obligatorio) {
    //       register(campoPersonalizado.campo_descripcion, requiredRule(intl, campoPersonalizado.campo_descripcion));
    //     } else {
    //       register(campoPersonalizado.campo_descripcion);
    //     }
    //   });
    // }
    // @ts-ignore
    register('notas', '');
    // @ts-ignore
    register('mutuas', []);
    register('cod_paciente_pagador');

    register('es_empresa');
    register('genero');
    register('avatar');

  }, [pacienteSelected, register]);
  useEffect(() => {
    register('cod_paciente_acompanante', requireAcompanyanteRule(intl, 'cod_paciente_acompanante', edadState, configuraciones));
  }, [register, edadState]);

  useEffect(() => {
    if (fecha_nacimiento_paciente) {
      setEdadState(fecha_nacimiento_paciente);
    }
  }, [fecha_nacimiento_paciente]);

  useEffect(() => {
    if (!create) {
      const notasDef = pacienteSelected && pacienteSelected.notas && pacienteSelected.notas !== '' ? pacienteSelected.notas : notas;
      if (notasDef !== '' && pacienteSelected !== null) {
        setNotasState(pacienteSelected.notas ? pacienteSelected.notas : notas);
      }
    }
  }, [notas, pacienteSelected]);

  useEffect(() => {
    if (!create && pacienteSelected?.mutuas && mutuas.length > 0) {
      setMutuasState(mutuas);
    }
  }, [mutuas]);

  useEffect(() => {
    setValue('notas', notasState);
  }, [notasState]);

  useEffect(() => {
    setValue('mutuas', mutuasState);
  }, [mutuasState]);

  const setNotas = ((text: string) => {
    const fecha = moment().format('DD-MM-YYYY HH:MM:SS').toString();
    setNotasState(`${notasState}\n[ ${fecha} - ${usuario} ]\n${text}\n`);
  });

  const handleChange = (name: string, value: any) => {
    // @ts-ignore
    setValue(name, value, { shouldValidate: true, shouldDirty: true });
  };
  const handleEdadChange = (edad:any) => {
    // @ts-ignore
    setEdadState(edad);
  };

  function showModal() {
    setModalState(true);
  }

  function closeModal() {
    setModalState(false);
  }

  function onDuplicadoModalOk() {
    setDuplicadoModal(false);
    dispatch(actions.createPacienteAction(pendingFormData));
    setPendingFormData({});
  }
  function onDuplicadoModalCancel() {
    setDuplicadoModal(false);
    dispatch(actions.unsetPacienteDuplicado());
  }

  const sendData = (signRgpd: boolean, print: boolean = false) => {
    handleSubmit((data) => {
      control.trigger();
      setSaveRecordatory(false);
      if (create) {
        setPendingFormData({
          data, signRgpd, print, campos_dinamicos: camposDinamicos,
        });
        dispatch(actions.comprobarPacientesduplicados({
          data, signRgpd, print, campos_dinamicos: camposDinamicos,
        }));
        /*
        dispatch(actions.createPacienteAction({
          data, signRgpd, print, campos_dinamicos: camposDinamicos,
        }));
        */
      } else {
        dispatch(actions.updatePacienteAction({ pacienteId: pacienteSelected.id, data, campos_dinamicos: camposDinamicos }));
      }
    })();
  };

  const handleCancel = (status: boolean) => {
      setCancelModalState(status);
      setSaveRecordatory(!status);
  }

  /**
  * Se encarga de ocultar cualquier campo del formulario utilizando los campos personalizados. Si por ejemplo en campos dinamos o personalizados viene el campo EMAIL con la propiedad visible a true, este campo se ocultará en el formulario
  * Esta función está repetida en BasicInfo, ContactInfo y AddInfo
  */
  const isHidden = (field: string) => {
    const campoPersonalizado = find(camposDinamicos,
      (campoPersonalizado: any) => campoPersonalizado.campo_descripcion === field);
    if (!campoPersonalizado) return false;
    return !campoPersonalizado.propiedades.visible;
  };
  const tieneMutuasBd = pacienteSelected?.mutuas && mutuas.length > 0;
  const headerData = [
    {
      translationId: 'pacientes.client_file.edit',
      text: 'Editar',
      onClick: () => {
        setOnWatch(false);
        history.push(generatePath(ROUTE_PACIENTES_EDIT, { pacienteId: pacienteSelected.id }));
      },
    },
    {
      icon: faPrint, visible: false, position: 'right', onClick: () => {},
    },
    {
      icon: faEllipsisH, visible: false, position: 'right', onClick: () => {},
    },
  ];
  
  const newClient: ReactElement = (
    <>
      {onWatch
          && <ActionsHeader anchor={NAVIGATION_ANCHOR} sticky data={headerData} />
      }
      {!watch &&
         <Prompt
         when={saveRecordatory}
         message='Está usted editando y hay cambios sin guardar, ¿desea descartarlos?'
       />
      }
      { (() => {
        if (loadingFields) return <Spin size="large" style={{ width: '100%', height: '100%' }} />;
        return (
          <form className="formContainer">
            <GenderSelectPatient watch={watch} onChange={handleChange} fotoPerfil={fotoPerfil} pacienteSelected={pacienteSelected} intl={intl} create={create}/>
            <BasicInfo
              camposDinamicos={camposDinamicos}
              hookForms={hookForms}
              watch={onWatch}
              handleChange={handleChange}
              onEdadChange={handleEdadChange}
            />
            <ContactInfo watch={onWatch} camposDinamicos={camposDinamicos} hookForms={hookForms} handleChange={handleChange} />
            <AddInfo watch={onWatch} camposDinamicos={camposDinamicos} hookForms={hookForms} handleChange={handleChange} />
            {!isHidden('mutuas') && tieneMutuasBd && <Mutuas mutuas={mutuasState} setMutuas={setMutuasState} />}
            {!isHidden('notas') && <Notas disabled={watch} notas={notasState} setNotas={setNotas} />}
            {!onWatch
              ? (
                <div className="footer_new">
                  {create
                    ? (
                      <>
                        <div onClick={showModal}>
                          <p className="blueLink">{intl.formatMessage({ id: 'pacientes.new_client.dont_want_sign' })}</p>
                        </div>
                        <div className="flexRow">
                          <Button className="buttonCancel" onClick={() => handleCancel(true)}>
                            {intl.formatMessage({ id: 'pacientes.new_client.cancel' })}
                          </Button>
                          {breakPoint.isDesktop
                            ? (
                              <>
                                <Button
                                  className="buttonSignPaper"
                                  onClick={() => sendData(false, true)}
                                >
                                  {intl.formatMessage({ id: 'pacientes.new_client.sign_in_paper' })}

                                </Button>
                                <Button
                                  className="buttonRGPD"
                                  type="primary"
                                  style={{ marginLeft: '8px' }}
                                  // TODO: Review this behaviour
                                  onClick={() => sendData(true)}
                                >
                                  {intl.formatMessage({ id: 'pacientes.new_client.sign_tablet' })}
                                </Button>
                              </>
                            )
                            : (
                              <>
                                <Button
                                  className="buttonRGPD2"
                                  type="primary"
                                  style={{ marginLeft: '8px' }}
                                  onClick={() => { sendData(true); }}
                                >
                                  {intl.formatMessage({ id: 'pacientes.new_client.sign_pgrd' })}
                                </Button>
                              </>
                            )
                        }
                        </div>
                      </>
                    )
                    : (
                      <>
                        <div />
                        <div className="flexRow">
                          <Button
                            className="buttonCancel"
                            onClick={() => handleCancel(true)}
                          >
                            {intl.formatMessage({ id: 'pacientes.new_client.cancel' })}
                          </Button>
                          <Button
                            className="buttonRGPD3"
                            type="primary"
                            style={{ marginLeft: '8px' }}
                            onClick={() => { sendData(false); }}
                            loading={guardandoPaciente}
                          >
                            {intl.formatMessage({ id: 'pacientes.new_client.save_changes' })}
                          </Button>
                        </div>
                      </>
                    )
                }
                </div>
              )
              : null
          }
          </form>
        );
      })()}
      <CancelModal
        visible={cancelModalState}
        onClose={() => handleCancel(false)}
        goBackOnContinue
        onContinue={() => (!watch && !create ? history.push(generatePath(ROUTE_PACIENTES_FILE, { pacienteId: pacienteSelected.id })) : null)}
      />
      <Modal
        title={(
          <Box>
            <Box><Text upperCase={false} lowerCase={false} children="" fontSize="20" fontWeight="600" translationId="paciente.anyadir_paciente_duplicado" /></Box>
          </Box>
        )}
        visible={duplicadoModal}
        onCancel={() => {onDuplicadoModalCancel()}}
        onOk={() => onDuplicadoModalOk()}
        cancelText="Cancelar"
        okText="Aceptar"

      >
        <Text upperCase={false} lowerCase={false} children="" translationId="paciente.anyadir_paciente_duplicado_contenido" />
      </Modal>
      <ModalDS
        closeModal={closeModal}
        modalState={modalState}
        sendData={sendData}
      />
    </>
  );
  let pageTitle = pacienteSelected ? pacienteSelected.nombre_completo : `Ficha (${params.pacienteId})`;
  if (create) {
    pageTitle = intl.formatMessage({ id: 'pacientes.grayContainer.new_client' });
  } else if (!watch) {
    pageTitle = pacienteSelected ? pacienteSelected.nombre_completo : `Ficha (${params.pacienteId})`;
  }
  const navigationItems = [
    {
      node: <Text children="" upperCase={false} lowerCase={false} translationId="navegacion.home" />,
      link: '',
    },
    {
      node: <Text children="" upperCase={false} lowerCase={false} translationId="navegacion.pacientes" />,
      link: '/pacientes/buscar',
    },
  ];
  if (!create) {
    navigationItems.push(
      {
        node: <Text upperCase={false} lowerCase={false} translationId={null}>{pacienteSelected ? pacienteSelected.nombre_completo : `Ficha (${params.pacienteId})`}</Text>,
        link: `/pacientes/file/${params.pacienteId}`,
      },
    );
  }
  return (
    <Page
      titulo={pageTitle}
      navigationItems={navigationItems}
      loading={!create && !pacienteSelected}
      hasStickyActionsHeader={watch}
    >
      <div className="patient patient-new">
        {newClient}
      </div>
    </Page>
  );
}

export default injectIntl(NewPatient);
